import { SessionBaseComponent } from '../../../../shared/components/session.base.component';
import { Component, Inject, Injector, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/shared/validators/custom-validators';
import { getFacilityByPermission, getForwarderByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { RfqCreationService } from '../../service/rfq-creation.service';
import { Dropdown } from 'primeng/dropdown';
import { NotificationSubScriptionService } from 'src/app/core/services/notification-sub-scription.service';
import { RfqSettingService } from '../../service/rfq-setting.service';
import * as ValidationUtils from 'src/app/core/utils/validation-functions';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { CommonService } from '../../service/common.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { LaasOption } from 'src/app/core/models/laas-option';

@Component({
  selector: 'laas-rfq-header-edit',
  templateUrl: './rfq-header-edit.component.html',
  styleUrls: ['./rfq-header-edit.component.scss']
})
export class RfqHeaderEditComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode : PermissionConstants = PermissionConstants.ViewRFQSetting;

  editHeaderForm : FormGroup;
  rfqData : any;
  rfqDetail : any;

  rfqStatusOptions : any[] = [];
  shipTermOptions: LaasOption[] = [];
  rfqCategoryTypeOptions : any[] = [];
  pickupLocationOptions : any[] = [];
  yesNoOption: any[] = [];
  customerOptions : any[] = [];
  countryOptions : any[] = [];
  allCityOptions: any[] = [];
  allAreaOptions: any[] = [];
  fromCityOptions : any[] = [];
  fromAreaOptions : any[] = [];
  toCityOptions : any[] = [];
  toAreaOptions : any[] = [];
  forwarderOptions : any[] = [];
  expressTermOptions : any[] = [];
  shippingTypeOptions : any[] = [];
  feeTypeOptions : any[] = [];
  calculationUnitOptions : any[] = [];
  currencyOptions : any[] = [];
  expressFromCityOptions : any[] = [];
  expressFromAreaOptions : any[] = [];
  expressToCityOptions : any[] = [];
  expressToAreaOptions : any[] = [];
  rfqDetailList : any[] = [];
  detailList : any[] = [];
  detailColumns : any[] = [];
  defaultDate : any;
  editDetailForm : FormGroup;
  submitted: boolean = false;
  disableDropdown1: boolean = false;
  disableDropdown2: boolean = false;
  facilityOptions: any[] = [];
  isConsolidationOptions: any[] = [];

  constructor(
    injector: Injector,
    private rfqCreationService : RfqCreationService,
    private commonService: CommonService,
    private commonDataService: CommonDataService,
    private facilityService : FacilityService,
    private notificationSubScriptionService : NotificationSubScriptionService,
    private dropdownOptionsService: DropdownOptionsService,
    private rfqSettingService : RfqSettingService,
    private datePipe: DatePipe,
    private fb: FormBuilder
  ) {

    super(injector);

    this.detailColumns = [
      { field: 'feeType', header: 'RFQPreview.SubTable.CostType' },
      { field: 'incoTerm', header: 'RFQPreview.SubTable.TradeTerm' },
      { field: 'shippingSectionDesc', header: 'RFQPreview.SubTable.TransportSectionDescription' },
      { field: 'currency', header: 'RFQPreview.SubTable.AccountingCurrency' },
      { field: 'unitPrice', header: 'RFQPreview.SubTable.UnitPrice' },
      { field: 'calculationUnit', header: 'RFQPreview.SubTable.CalculationUnit' },
      { field: 'intervalUnitStart', header: 'RFQPreview.SubTable.CalculationRangeStart' },
      { field: 'intervalUnitEnd', header: 'RFQPreview.SubTable.CalculationRangeEnd' },
      { field: 'minimalCharge', header: 'RFQPreview.SubTable.MinimumCost' },
      { field: 'remark', header: 'RFQPreview.SubTable.Remarks' },
      { field: 'isTieredGroup', header: 'RFQPreview.SubTable.IsRFQ' },
    ];



    this.editHeaderForm = this.fb.group({
      facility: null,
      facilityList: null,
      seqNo: null,
      forwarder : [null, Validators.required ] ,
      status : [null, Validators.required ] ,
      fromCountry : [null, Validators.required ] ,
      fromCity : [null, Validators.required ] ,
      fromArea : null ,
      expressFromArea : null ,
      toCountry : [null, Validators.required ] ,
      toCity : [null, Validators.required ] ,
      toArea : null ,
      expressToArea : null ,
      rfqCategory : [null, Validators.required ] ,
      awbAddress : null,
      expressTerm : null,
      consigneekey : null,
      consigneeName : null,
      effectStartDate: [null, Validators.required ] ,
      effectEndDate: [null, Validators.required ] ,
      isActivated : [0, Validators.required ] ,
      remark: null,
      createUser : null,
      createDt : null ,
      updateUser :[null, Validators.required ] ,
      updateDt : [null, Validators.required ] ,
      currency:  [null, Validators.required ] ,
      outsourcingCompany:  null,
      shippingType: null,
      isConsolidation:['N', Validators.required ]
    });

    this.editDetailForm = this.fb.group({
      details: this.fb.array([]),
    });

  }




  async ngOnInit(): Promise<void> {

    await super.ngOnInit();

    this.rfqData = await  this.rfqSettingService.getRfq(this.routeStateService.getCurrent().data);
    this.rfqDetail = await this.rfqSettingService.getRfqDetail(this.routeStateService.getCurrent().data);

    this.defaultDate = new Date();

    console.log(" rfqData :",  this.rfqData);
    console.log(" rfqDetail :",  this.rfqDetail);


    let facilityList = this.rfqData.facility.split(',');
    this.editHeaderForm.controls.facilityList.setValue(facilityList);

    this.editHeaderForm.controls.facility.setValue(this.rfqData.facility);
    this.editHeaderForm.controls.forwarder.setValue(this.rfqData.forwarder);
    this.editHeaderForm.controls.seqNo.setValue(this.rfqData.seqNo);
    this.editHeaderForm.controls.status.setValue(this.rfqData.status);
    this.editHeaderForm.controls.fromCountry.setValue(this.rfqData.fromCountry);
    this.editHeaderForm.controls.fromCity.setValue(this.rfqData.fromCity);
    this.editHeaderForm.controls.fromArea.setValue(this.rfqData.fromArea);
    this.editHeaderForm.controls.expressFromArea.setValue(this.rfqData.expressFromArea);
    this.editHeaderForm.controls.toCountry.setValue(this.rfqData.toCountry);
    this.editHeaderForm.controls.toCity.setValue(this.rfqData.toCity);
    this.editHeaderForm.controls.toArea.setValue(this.rfqData.toArea);
    this.editHeaderForm.controls.expressToArea.setValue(this.rfqData.expressToArea);
    this.editHeaderForm.controls.currency.setValue(this.rfqData.currency);
    this.editHeaderForm.controls.rfqCategory.setValue(this.rfqData.rfqCategory);
    this.editHeaderForm.controls.awbAddress.setValue(this.rfqData.awbAddress);
    this.editHeaderForm.controls.expressTerm.setValue(this.rfqData.expressTerm);
    this.editHeaderForm.controls.consigneekey.setValue(this.rfqData.consigneekey);
    this.editHeaderForm.controls.consigneeName.setValue(this.rfqData.consigneeName);
    this.editHeaderForm.controls.outsourcingCompany.setValue(this.rfqData.outsourcingCompany);
    this.editHeaderForm.controls.shippingType.setValue(this.rfqData.shippingType);
    this.editHeaderForm.controls.isConsolidation.setValue(this.rfqData.isConsolidation);
    // this.editHeaderForm.controls.effectStartDate.setValue(this.rfqData.effectStartDate);
    // this.editHeaderForm.controls.effectEndDate.setValue(this.rfqData.effectEndDate);
    this.editHeaderForm.controls.isActivated.setValue(this.rfqData.isActivated);
    this.editHeaderForm.controls.remark.setValue(this.rfqData.remark);
    this.editHeaderForm.controls.createUser.setValue(this.rfqData.createUser);
    this.editHeaderForm.controls.createDt.setValue(this.rfqData.createDt);
    this.editHeaderForm.controls.updateUser.setValue(this.userProfile.userName);
    this.editHeaderForm.controls.updateDt.setValue(this.defaultDate);


    let effectStartDateTimeZone = this.datePipe.transform(this.rfqData.effectStartDate, 'yyyy-MM-dd', this.laasSetting.facilityTimeZone);
    let effectEndDateTimeZone = this.datePipe.transform(this.rfqData.effectEndDate, 'yyyy-MM-dd', this.laasSetting.facilityTimeZone);

    if(effectStartDateTimeZone!=null){
      this.editHeaderForm.controls.effectStartDate.setValue(effectStartDateTimeZone);
    }

    if(effectEndDateTimeZone!=null){
      this.editHeaderForm.controls.effectEndDate.setValue(effectEndDateTimeZone);
    }

    this.getExpressInfo();

    //
    this.editDetailForm.markAllAsTouched();
    for(var i = 0 ; i < this.rfqDetail.length ; i++){
      var temp = this.rfqDetail[i];
      this.addDetail();
      this.details.controls[i].setValue(temp);
    }

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options.filter((x: any) => {
          return ( this.userProfile.userType == UserType.SuperAdmin.toString() ||
          this.userProfile.userType == UserType.Shipping.toString() ||
           getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });


    this.dropdownOptionsService.getRFQStatusOptions()
    .subscribe({
      next: (options: any[]) => {
        this.rfqStatusOptions = options.map(x => ({ label: x.optionDesc, value: Number(x.optionCode) }));
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShipTerm').subscribe({
      next: result => {
        this.shipTermOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
        this.shipTermOptions.unshift({
          label: 'ALL',
          value: 'ALL'
        });
      }
    });

    // 國家
    this.dropdownOptionsService.getVCountryOptions()
    .subscribe({
      next: (options: any[]) => {
        this.countryOptions = options.map(x => ({ label: x.countryName, value: x.countryCode }));
        this.countryOptions.unshift({
          label: 'ALL',
          value: 'ALL'
        });
      }
    });

    // 城市
    this.dropdownOptionsService.getVCityOptions()
    .subscribe({
      next: (options: any[]) => {
        this.allCityOptions = options.map(x => ({ label: x.name, value: x.seqNo.toString() , expressArea : x.expressArea , country: x.country }));
        this.getFromCityOptions();
        this.getToCityOptions();
      }
    });

    // 區域
    this.dropdownOptionsService.getVAreaOptions()
    .subscribe({
      next: (options: any[]) => {
        this.allAreaOptions = options.map(x => ({ label: x.areaName, value: x.areaCode , city : x.city }));
        this.fromAreaOptions = this.allAreaOptions.filter(x => x.city == this.editHeaderForm.value.fromCity );
        this.toAreaOptions = this.allAreaOptions.filter(x => x.city == this.editHeaderForm.value.toCity );
      }
    });

    this.dropdownOptionsService.getRfqCategoryTypeOptions()
    .subscribe({
      next: (options: any[]) => {
        this.rfqCategoryTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionsService.getPickupLocationOptions()
    .subscribe({
      next: (options: any[]) => {
        this.pickupLocationOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionsService.findFacilityOptionsByOptionType("ExpressTerm")
    .subscribe({
      next: (options: any[]) => {
        this.expressTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionsService.findFacilityOptionsByOptionType("ShippingType")
    .subscribe({
      next: (options: any[]) => {
        this.shippingTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionsService.findFeeTypeByFeeTypeCategory("RFQ")
      .subscribe({
      next: (options: any[]) => {
        this.feeTypeOptions = options.map(x => ({ label: x.feeTypeName, value: x.feeTypeCode }));
      }
    });


    this.dropdownOptionsService.findFacilityOptionsByOptionType("CalculationUnit")
      .subscribe({
      next: (options: any[]) => {
        this.calculationUnitOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });


    this.commonService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.currency_code}-${x.currency_name}`,
            value: x.currency_code,
          };
        });
      }
    });

    this.yesNoOption = [
      { label: 'N', value: 0 },
      { label: 'Y', value: 1 }
    ];

    this.notificationSubScriptionService.getCustomerOptionsByKey(this.rfqData.consigneekey).subscribe({
      next: (options: any[]) => {
        this.customerOptions = options.map(x => ({ label: x.customerCode+ '-'  +x.customerName + '-'  +x.engName , value: x.customerCode }));
      }
    });

    this.dropdownOptionsService.getFacilityOptions()
    .subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.filter(x => {
          return this.userProfile.userType == UserType.SuperAdmin.toString() ||
              getFacilityByPermission(this.userProfile, this.permissionCode).includes(null) ||
              getFacilityByPermission(this.userProfile, this.permissionCode).includes(x.optionCode)
        })
        .map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.isConsolidationOptions = [
      { label: 'N', value: 'N' },
      { label: 'Y', value: 'Y' }
    ];

  }



  getFromCityOptions(): void {

    if(this.editHeaderForm.value.fromCountry == 'ALL'){
      this.fromCityOptions = [{ label : 'ALL' , value : 'ALL' }];
      this.fromAreaOptions = [{ label : null , value : null }];
      this.expressFromAreaOptions = [{ label : 'ALL' , value : 'ALL' }];
      this.editHeaderForm.controls.fromCity.setValue("ALL");
      this.editHeaderForm.controls.fromArea.setValue(null);
      this.editHeaderForm.controls.expressFromArea.setValue("ALL");
      this.disableDropdown1 = true;
    }else{
      this.editHeaderForm.value.fromCity = null;
      this.editHeaderForm.value.fromArea = null;
      this.fromCityOptions = this.allCityOptions.filter(x => x.country == this.editHeaderForm.value.fromCountry);

      this.editHeaderForm.value.expressFromArea = null;
      const temp = [...new Set(this.allCityOptions.filter(x => x.country == this.editHeaderForm.value.fromCountry).map(item => item.expressArea))];
      this.expressFromAreaOptions = temp.map(item => ({ label : item , value : item }) );

      this.disableDropdown1 = false;
    }

  }

  getFromAreaOptions(): void {
      this.editHeaderForm.value.fromArea = null;
      this.fromAreaOptions = this.allAreaOptions.filter(x => x.city == this.editHeaderForm.value.fromCity );
  }


  getToCityOptions(): void {

    if(this.editHeaderForm.value.toCountry == 'ALL'){
      this.toCityOptions = [{ label : 'ALL' , value : 'ALL' }];
      this.toAreaOptions = [{ label : null , value : null }];
      this.expressToAreaOptions = [{ label : 'ALL' , value : 'ALL' }];
      this.editHeaderForm.controls.toCity.setValue("ALL");
      this.editHeaderForm.controls.toArea.setValue(null);
      this.editHeaderForm.controls.expressToArea.setValue("ALL");
      this.disableDropdown2 = true;
    }else{
      this.editHeaderForm.value.toCity = null;
      this.editHeaderForm.value.toArea = null;
      this.toCityOptions = this.allCityOptions.filter(x => x.country == this.editHeaderForm.value.toCountry);

      this.editHeaderForm.value.expressToArea = null;
      const temp = [...new Set(this.allCityOptions.filter(x => x.country == this.editHeaderForm.value.toCountry).map(item => item.expressArea))];
      this.expressToAreaOptions = temp.map(item => ({ label : item , value : item }) );

      this.disableDropdown2 = false;
    }

  }

  getToAreaOptions(): void {
    this.editHeaderForm.value.toArea = null;
    this.toAreaOptions = this.allAreaOptions.filter(x => x.city == this.editHeaderForm.value.toCity );
  }


  getCustomerOptionsByKey(event: any): void {
    const key: string = event.filter;
    if(key != null && key.length > 1 ){
      this.notificationSubScriptionService.getCustomerOptionsByKey(key).subscribe({
        next: (options: any[]) => {
          this.customerOptions = options.map(x => ({ label: x.customerCode+ '-'  +x.customerName + '-'  +x.engName , value: x.customerCode }));
        }
      });
    }
  }


  addDetail(){
    this.editDetailForm.markAllAsTouched();
    this.details.push(this.addControls());
  }


  private addControls() {

    return new FormGroup({
      seqNo : new FormControl(null),
      rfqSeqNo : new FormControl(null),
      feeType: new FormControl(null, [Validators.required]),
      incoTerm: new FormControl(null, [Validators.required]),
      shippingSectionDesc: new FormControl(null),
      shippingType: new FormControl(null),
      currency : new FormControl(null, [Validators.required]),
      unitPrice : new FormControl(null, [Validators.required]),
      calculationUnit :  new FormControl(null),
      intervalUnitStart : new FormControl(null),
      intervalUnitEnd : new FormControl(null),
      minimalCharge : new FormControl(null, [Validators.required]),
      isTieredGroup : new FormControl(null, [Validators.required]),
      remark : new FormControl(null),
      createUser : new FormControl(this.userProfile.userName),
      createDt : new FormControl(this.defaultDate),
      updateUser : new FormControl(this.userProfile.userName),
      updateDt : new FormControl(this.defaultDate),
    });

  }

  get details(): FormArray {
    return this.editDetailForm.get("details") as FormArray;
  }

  private populateData() {
    this.rfqDetailList.forEach((data, index) => {
      this.addDetail();
      this.details.controls[index].setValue(data);
    });
  }

  deleteBtnClick(event: any, detailList : any, idx: number ): void {

    this.confirmationService.confirm({
      message: this.translateService.instant('RFQSetting.Confirm.ConfirmDeleteRFQDetail'),
      header: '刪除',
      rejectVisible: true,
      accept: () => {
        let seqNo = this.details.controls[idx].value.seqNo;
        if(seqNo == null){
          this.details.removeAt(idx);
        }else{
          this.rfqSettingService.deleteRfqDetail(seqNo)
          .subscribe({
            next: result => {
              this.details.removeAt(idx);
            },
            error: (err: any) => {
              this.toastErrorMessage(err.error);
            }
          });
        }

      },
      reject: () => {
        this.confirmationService.close();
      }
    });

  }

  detailsControls(index: number) {
    return this.details.controls[index].value;
  }

  showValidationMessage(control: AbstractControl | null, submitted: boolean): boolean {
    return ValidationUtils.showValidationMessage(control, submitted);
  }

  editClick(){
    let facilityList = this.editHeaderForm.value.facilityList;
    if(facilityList == null || facilityList.length == 0){
      this.editHeaderForm.controls.facility.setValue(this.laasSetting.facility);
    }else{
      let str = facilityList.toString();
      this.editHeaderForm.controls.facility.setValue(str);
    }


    if(isNullOrEmpty(this.editHeaderForm.controls.consigneekey)){
      this.editHeaderForm.controls.consigneeName.setValue(null);
    }

    if (this.editHeaderForm.invalid) {
      this.submitted = true;
      this.toastService.warn(this.translateService.instant('RFQSetting.Alert.CheckMainPage'));
      this.loader.hide();
      return;
    }

    if (this.editDetailForm.invalid) {
      this.submitted = true;
      this.toastService.warn(this.translateService.instant('RFQSetting.Alert.CheckDetailedList'));
      this.loader.hide();
      return;
    }


    var effectStartDate = this.editDetailForm.value.effectStartDate;
    var effectEndDate = this.editDetailForm.value.effectEndDate;

    if(effectStartDate > effectEndDate){
      this.toastService.warn(this.translateService.instant('RFQSetting.Alert.EffectiveGreater'));
      this.loader.hide();
      return;
    }



    var rfqEntity = this.editHeaderForm.value;
    var rfqDetailEntity = this.editDetailForm.value;
    let  obj = {rfqEntity : rfqEntity , rfqDetailEntity : rfqDetailEntity.details };

    this.confirmationService.confirm({
      message: this.translateService.instant('RFQSetting.Confirm.ConfirmEditRFQ'),
      header: 'EDIT',
      rejectVisible: true,
      accept: () => {

        this.rfqSettingService.updateRfq(obj)
        .subscribe({
          next: result => {
            if(result == "OK"){
              this.toastService.info(this.translateService.instant('RFQSetting.Info.UpdateSuccess'));
              this.routeStateService.navigateTo('/Setting/RfqSetting');
            }
            this.loader.hide();
          },
          error: (err: any) => {
            this.toastErrorMessage(err.error);
          }
        });

      },
      reject: () => {
        this.confirmationService.close();
      }
    });

  }

  changeConsignee(event: any) {
    if (!event) {
      this.editHeaderForm.controls.consigneeName.setValue(null);
      return;
    }
    const selectedOption = this.customerOptions.find(opt => opt.value === event);
    if (selectedOption && selectedOption.label) {
      let label = selectedOption.label;
      const name = label.substring(label.indexOf('-') + 1).trim();
      this.editHeaderForm.controls.consigneeName.setValue(name);
    }
  }

  getExpressInfo(){

    this.facilityService.getFacilityForwarderExpressInfo(this.laasSetting.facility, this.editHeaderForm.value.forwarder)
    .subscribe({
      next: (result: any) => {

        var isExpressBill = result.isExpressBill;

        // 改變必填欄位
        if(isExpressBill == 1){

          this.editHeaderForm.controls.fromCity.clearValidators();
          this.editHeaderForm.controls.fromCity.updateValueAndValidity();

          this.editHeaderForm.controls.toCity.clearValidators();
          this.editHeaderForm.controls.toCity.updateValueAndValidity();

          this.editHeaderForm.controls.expressFromArea.setValidators(Validators.required);
          this.editHeaderForm.controls.expressFromArea.updateValueAndValidity();

          this.editHeaderForm.controls.expressToArea.setValidators(Validators.required);
          this.editHeaderForm.controls.expressToArea.updateValueAndValidity();

        }else{

          this.editHeaderForm.controls.fromCity.setValidators(Validators.required);
          this.editHeaderForm.controls.fromCity.updateValueAndValidity();

          this.editHeaderForm.controls.toCity.setValidators(Validators.required);
          this.editHeaderForm.controls.toCity.updateValueAndValidity();

          this.editHeaderForm.controls.expressFromArea.clearValidators();
          this.editHeaderForm.controls.expressFromArea.updateValueAndValidity();

          this.editHeaderForm.controls.expressToArea.clearValidators();
          this.editHeaderForm.controls.expressToArea.updateValueAndValidity();

        }

      },
      error: (err: HttpErrorResponse) => {
        this.toastErrorMessage(err.error);
      }
    });

  }


onCustomerListLoaded(list: any[]) {
  this.customerOptions = list;
  const currentKey = this.editHeaderForm.controls.consigneekey.value;
  if (currentKey) {
    this.changeConsignee(currentKey);
  }
}


}
